(function () {
  if (window.__customerPhotosInit) return;
  window.__customerPhotosInit = true;

  function setup(viewport) {
    if (viewport.dataset.cphReady === "true") return;
    viewport.dataset.cphReady = "true";

    var track = viewport.querySelector("[data-cph-track]");
    var prevButton = viewport.querySelector("[data-cph-prev]");
    var nextButton = viewport.querySelector("[data-cph-next]");
    if (!track) return;

    var originals = Array.prototype.slice.call(track.querySelectorAll("[data-cph-item]"));
    var realCount = originals.length;
    if (!realCount) return;

    /* Com 1 ou 2 fotos não há o que rodar em loop: mantém o carrossel com limites. */
    var loop = realCount > 2;

    /* ---------- Clones para o loop infinito ---------- */
    function makeClone(node) {
      var clone = node.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-cph-clone", "");
      clone.removeAttribute("id");

      /* Clones não podem carregar os atributos do editor de temas nem ids repetidos. */
      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr.name.indexOf("data-shopify") === 0) clone.removeAttribute(attr.name);
      });
      Array.prototype.slice.call(clone.querySelectorAll("[id]")).forEach(function (el) {
        el.removeAttribute("id");
      });
      Array.prototype.slice.call(clone.querySelectorAll("a")).forEach(function (el) {
        el.setAttribute("tabindex", "-1");
      });

      return clone;
    }

    function buildCopies(count) {
      var fragment = document.createDocumentFragment();
      for (var copy = 0; copy < count; copy++) {
        originals.forEach(function (item) {
          fragment.appendChild(makeClone(item));
        });
      }
      return fragment;
    }

    var offsetStart = 0;

    if (loop) {
      /* Clona conjuntos inteiros até cobrir a largura da tela dos dois lados.
         O teto de 3 evita inflar o DOM se a seção estiver oculta na medição. */
      var setWidth = realCount * (originals[0].offsetWidth || 300);
      var copies = Math.min(3, Math.max(1, Math.ceil(window.innerWidth / setWidth)));

      track.insertBefore(buildCopies(copies), track.firstChild);
      track.appendChild(buildCopies(copies));
      offsetStart = copies * realCount;
    }

    var items = Array.prototype.slice.call(track.querySelectorAll("[data-cph-item]"));

    var index = offsetStart + Math.floor(realCount / 2);
    var autoplayTimer = null;
    var autoplayEnabled = viewport.dataset.autoplay === "true";
    var autoplayDelay = (parseInt(viewport.dataset.autoplaySpeed, 10) || 4) * 1000;

    function render(animate) {
      /* is-snapping corta a transição da faixa E das fotos, para o salto do loop não piscar. */
      if (animate === false) viewport.classList.add("is-snapping");

      var active = items[index];
      var offset = viewport.clientWidth / 2 - (active.offsetLeft + active.offsetWidth / 2);
      track.style.transform = "translateX(" + offset + "px)";

      items.forEach(function (item, i) {
        item.classList.toggle("is-active", i === index);
        /* A foto central fica por cima; as vizinhas descem em camadas. */
        item.style.zIndex = String(items.length - Math.abs(i - index));
      });

      if (!loop) {
        if (prevButton) prevButton.disabled = index === 0;
        if (nextButton) nextButton.disabled = index === items.length - 1;
      }

      if (animate === false) {
        /* Força o reflow para reativar a transição sem animar o salto. */
        void track.offsetWidth;
        viewport.classList.remove("is-snapping");
      }
    }

    function goTo(nextIndex) {
      if (!loop) {
        index = Math.max(0, Math.min(items.length - 1, nextIndex));
        render();
        return;
      }

      /* Saiu do conjunto original: reposiciona sem animar na cópia equivalente
         (imagem idêntica, então o salto é invisível) e só depois anima. */
      if (nextIndex < offsetStart || nextIndex >= offsetStart + realCount) {
        var shift = nextIndex < offsetStart ? realCount : -realCount;
        index += shift;
        nextIndex += shift;
        render(false);
      }

      index = nextIndex;
      render();
    }

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        stopAutoplay();
        goTo(index - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        stopAutoplay();
        goTo(index + 1);
      });
    }

    items.forEach(function (item, i) {
      item.addEventListener("click", function (event) {
        if (i === index) return;
        /* Clicar numa foto lateral só centraliza ela, sem abrir o link. */
        event.preventDefault();
        stopAutoplay();
        goTo(i);
      });
    });

    /* ---------- Arrastar / deslizar ---------- */
    var dragStartX = 0;
    var dragging = false;

    function onDragStart(clientX) {
      dragging = true;
      dragStartX = clientX;
      viewport.classList.add("is-dragging");
    }

    function onDragEnd(clientX) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove("is-dragging");

      var delta = clientX - dragStartX;
      if (Math.abs(delta) < 40) return;

      stopAutoplay();
      goTo(delta < 0 ? index + 1 : index - 1);
    }

    viewport.addEventListener(
      "touchstart",
      function (event) {
        onDragStart(event.touches[0].clientX);
      },
      { passive: true }
    );

    viewport.addEventListener(
      "touchend",
      function (event) {
        onDragEnd(event.changedTouches[0].clientX);
      },
      { passive: true }
    );

    viewport.addEventListener("mousedown", function (event) {
      onDragStart(event.clientX);
    });

    window.addEventListener("mouseup", function (event) {
      onDragEnd(event.clientX);
    });

    /* ---------- Teclado ---------- */
    viewport.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft") {
        stopAutoplay();
        goTo(index - 1);
      } else if (event.key === "ArrowRight") {
        stopAutoplay();
        goTo(index + 1);
      }
    });

    /* ---------- Autoplay ---------- */
    function startAutoplay() {
      if (!autoplayEnabled || autoplayTimer) return;
      autoplayTimer = setInterval(function () {
        if (loop) {
          goTo(index + 1);
        } else {
          index = index >= items.length - 1 ? 0 : index + 1;
          render();
        }
      }, autoplayDelay);
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    viewport.addEventListener("mouseenter", stopAutoplay);
    viewport.addEventListener("mouseleave", startAutoplay);

    /* ---------- Recalcula em resize ---------- */
    var resizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        render(false);
      }, 120);
    });

    render(false);
    startAutoplay();

    /* Reposiciona depois que as imagens carregarem (a largura pode mudar). */
    window.addEventListener("load", function () {
      render(false);
    });
  }

  function init() {
    var viewports = document.querySelectorAll("[data-customer-photos]");
    Array.prototype.forEach.call(viewports, setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
